import React from 'react'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Box } from 'widgets/Box'
import { FilledButton } from 'widgets/Button/FilledButton'
import { Text } from 'widgets/Text'

interface Props {
  onPress: () => void
}

export const AddStepsButton = ({ onPress }: Props) => {
  const insets = useSafeAreaInsets()

  const styles = StyleSheet.create({
    footerContainer: {
      paddingBottom: insets.bottom,
    },
  })

  return (
    <Box margin='md' style={styles.footerContainer}>
      <Box>
        <FilledButton borderRadius='sm' title='Add Steps' height={50} onPress={onPress} />
      </Box>
      <Box flexDirection='row' align='center' justifyContent='center' margin='md'>
        <Text align='center' fontSize='sm' color='black'>
          Select multiple images to add multiple steps at once. No media? Press the + sign above to
          add an individual step.
        </Text>
      </Box>
    </Box>
  )
}
